import { Alert as MuiAlert, type AlertProps as MuiAlertProps } from '@mui/material';
import { forwardRef } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiAlertProps, 'slots' | 'slotProps' | 'iconMapping' | 'elevation' | 'square'>>;

// Forward the ref: Snackbar's transition needs the DOM node to animate its child.
export const Alert = forwardRef<HTMLDivElement, Props>(function Alert(props, ref) {
  return <MuiAlert ref={ref} {...props} />;
});

export type { Props as AlertProps };
